import { useField } from './useField';
import { utils } from '../utils';

export type LoadingParams = {
  percentage: number;
  message: string;
  delay: number;
};

export const useLoading = <T>() => {
  const loadingMessage = useField<string | undefined>('');
  const loadingPercentage = useField<number | undefined>(0);

  const setLoading = (loadingParams: LoadingParams[]) => {
    utils.helpers.configureProgressBar(loadingPercentage.setValue, loadingMessage.setValue, loadingParams);
  };

  return { loadingMessage, loadingPercentage, setLoading };
};
